import SkeletonLink from "components/common/skeleton-link"
import { useTranslation } from "lib/i18n/translation"

import OffersLacinetekIcon from "static/assets/icons/offers-lacinetek.svg"

export const BlockOfferLacinetek = () => {
	const { c } = useTranslation()

	return (
		<div className="item">
			<div className="item-content">
				<div className="inline">
					<figure className="small">
						<OffersLacinetekIcon title={c("gift-icon")} />
					</figure>
					<h3 className="title">{c("gift-icon")}</h3>
				</div>
				<SkeletonLink href="/offer-lacinetek" >
					<a
						href="#"
						title={c("learn-more-about")}
						className="button full"
					>
						{c("gift-icon")}
					</a>
				</SkeletonLink>
			</div>
		</div>
	)
}
